import React, {useState, useEffect} from 'react';
import BackLink from "../BackLink";
import useGet from "../../hooks/useGet";
import {useSurveyContext} from "../../context/SurveyContext";
import Question from "./questions/Question";
import {getErrors, isFormValid} from "../../utils/questionnaireUtils";
import {postToHub} from "../../actions/networkActions";
import {getBackToDashboardText} from "../../utils/themeUtils";
import { Trans, useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';

function Survey({title, preSurveySection, postSurveySection=null, category, reponseKeyName}) {
    const [error, setError] = useState("");
    const [submitInProgress, setSubmitInProgress] = useState(false);
    const data = useGet(`precruise/questions/${category}`, {});
    const {survey, dispatch} = useSurveyContext();
    const {t} = useLingui();
    const activePart = 0;

    useEffect(() => {
        if(!data[reponseKeyName]) {
            return;
        }

        const {passenger, [reponseKeyName]: {questions, answers = {}, parts}} = data;

        dispatch({
            type: "SET_SURVEY_DATA",
            passenger,
            answers,
            questions,
            parts,
        });
    }, [data, dispatch, reponseKeyName]);


    if(!survey.passenger || !survey.passenger.passengerId) {
        return (<div className="container mx-auto mt-12">
            <span translate="no"><Trans id="loading">loading</Trans>...</span>
        </div>)
    }

    const buttonEnabled = isFormValid(survey.questions, survey.answers, survey.passenger, activePart);
    
    async function submit() {
        if(validateForm() && !submitInProgress) {
            const body = {
                passengerId: survey.passenger.passengerId,
                category,
                answers: survey.answers,
            }

            setSubmitInProgress(true);
            const result = await postToHub('precruise/questions/submitAnswers', body);
            setSubmitInProgress(false);

            if(result === "") {
                navigate(t({id: '/dashboard'}));
            }
            else {
                setError("There has been an error please try again");
            }
        }
    }

    function validateForm() {
        const errors = getErrors(survey.questions, survey.answers, survey.passenger, activePart);

        dispatch({
            type: "SET_ERRORS",
            errors,
        });

        return Object.keys(errors).length === 0;
    }

    return (
        <div className="container mx-auto">
            <div className="mt-4">
            <BackLink to={t({id: "/dashboard"})} text={getBackToDashboardText()} />
            </div>
            <h1>{title}</h1>

            {preSurveySection}

            <div className="mt-6">
                {survey.questions.map((question, index) =>
                    <Question
                        key={question.id}
                        activePart={activePart}
                        isFirst={index === 0}
                        question={question}
                    />
                )}
            </div>

            {survey.parts && survey.parts[activePart]?.partInfoHtmlBottom &&
                <div dangerouslySetInnerHTML={{__html: survey.parts[activePart].partInfoHtmlBottom}} />
            }

            {postSurveySection}

            {error &&
            <div className="mt-4 text-red">
                {error}
            </div>}

            <div className="mt-6 mb-8 xl:mb-12">
                <button
                    className={`action-button w-mobile ${buttonEnabled && !submitInProgress ? "action-button-enabled" : "action-button-disabled"}`}
                    onClick={submit}
                >
                    <Trans id="next">Next</Trans>
                </button>
            </div>
        </div>
    );
}

export default Survey;